import type { DentalCaseData, PatientListItem } from "../types/dental";

export const mockPatientList: PatientListItem[] = [
  {
    patientId: "patient-001",
    patientName: "Ali Khan",
    caseId: "case-001",
    caseName: "Initial Ortho Review",
  },
  {
    patientId: "patient-002",
    patientName: "Sara Ahmed",
    caseId: "case-002",
    caseName: "Upper-Lower Alignment",
  },
  {
    patientId: "patient-003",
    patientName: "Usman Tariq",
    caseId: "case-003",
    caseName: "Restorative Planning",
  },
  {
    patientId: "patient-004",
    patientName: "Hina Malik",
    caseId: "case-004",
    caseName: "Crowding Assessment",
  },
  {
    patientId: "patient-005",
    patientName: "Bilal Hussain",
    caseId: "case-005",
    caseName: "Occlusion Check",
  },
];

export const mockDentalCases: DentalCaseData[] = [
  {
    summary: {
      caseId: "case-001",
      caseName: "Initial Ortho Review",
      patientId: "patient-001",
      patientName: "Ali Khan",
      doctorName: "Dr. Salman Raza",
    },
    jaws: {
      upper: {
        jawType: "upper",
        width: 104,
        depth: 42,
        height: 18,
        toothCount: 16,
      },
      lower: {
        jawType: "lower",
        width: 96,
        depth: 34,
        height: 0,
        toothCount: 16,
      },
    },
    prescriptionItems: [
      {
        itemId: "rx-001",
        title: "Crown on T4",
        procedureType: "crown",
        status: "prescribed",
        target: {
          targetType: "single_tooth",
          jaw: "upper",
          teeth: ["T4"],
        },
        doctorNotes: "Full coverage crown required on T4.",
        material: "Zirconia",
        shade: "A2",
        productionNotes: "Standard crown workflow.",
      },
      {
        itemId: "rx-002",
        title: "Crown on T16",
        procedureType: "crown",
        status: "in_planning",
        target: {
          targetType: "single_tooth",
          jaw: "upper",
          teeth: ["T16"],
        },
        doctorNotes: "Check occlusion clearance carefully.",
        material: "Zirconia",
        shade: "A1",
        productionNotes: "Review margin line before release.",
      },
      {
        itemId: "rx-003",
        title: "Implant on T30",
        procedureType: "implant",
        status: "ready_for_production",
        target: {
          targetType: "single_tooth",
          jaw: "lower",
          teeth: ["T30"],
        },
        doctorNotes: "Implant-supported restoration needed.",
        material: "Titanium base + crown",
        shade: "A2",
        productionNotes: "Use catalog implant platform match.",
      },
    ],
    restorationPlans: [
      {
        planId: "rp-001",
        prescriptionItemId: "rx-001",
        title: "Restoration Plan for Crown on T4",
        procedureType: "crown",
        status: "in_design",
        targetJaw: "upper",
        targetTeeth: ["T4"],
        selectedCatalogItem: "CROWN-ZIRC-STANDARD",
        material: "Zirconia",
        shade: "A2",
        spacingNotes: "Adequate occlusal clearance.",
        designNotes: "Use standard crown emergence profile.",
        productionNotes: "Ready after design review.",
      },
    ],
  },
  {
    summary: {
      caseId: "case-002",
      caseName: "Upper-Lower Alignment",
      patientId: "patient-002",
      patientName: "Sara Ahmed",
      doctorName: "Dr. Nadia Mir",
    },
    jaws: {
      upper: {
        jawType: "upper",
        width: 110,
        depth: 45,
        height: 20,
        toothCount: 16,
      },
      lower: {
        jawType: "lower",
        width: 100,
        depth: 36,
        height: 2,
        toothCount: 16,
      },
    },
    prescriptionItems: [
      {
        itemId: "rx-004",
        title: "Bridge T12-T14",
        procedureType: "bridge",
        status: "prescribed",
        target: {
          targetType: "range",
          jaw: "upper",
          teeth: ["T12", "T13", "T14"],
          rangeStart: "T12",
          rangeEnd: "T14",
        },
        doctorNotes: "Three-unit bridge in the upper arch.",
        material: "Zirconia",
        shade: "A2",
        productionNotes: "Confirm pontic profile.",
      },
      {
        itemId: "rx-005",
        title: "Veneers T7-T10",
        procedureType: "veneer",
        status: "in_planning",
        target: {
          targetType: "range",
          jaw: "upper",
          teeth: ["T7", "T8", "T9", "T10"],
          rangeStart: "T7",
          rangeEnd: "T10",
        },
        doctorNotes: "Cosmetic veneer set.",
        material: "Lithium Disilicate",
        shade: "BL2",
        productionNotes: "High esthetic case.",
      },
    ],
    restorationPlans: [],
  },
  {
    summary: {
      caseId: "case-003",
      caseName: "Restorative Planning",
      patientId: "patient-003",
      patientName: "Usman Tariq",
      doctorName: "Dr. Fahad Anwar",
    },
    jaws: {
      upper: {
        jawType: "upper",
        width: 102,
        depth: 40,
        height: 16,
        toothCount: 16,
      },
      lower: {
        jawType: "lower",
        width: 95,
        depth: 32,
        height: -1,
        toothCount: 16,
      },
    },
    prescriptionItems: [
      {
        itemId: "rx-006",
        title: "Inlay/Onlay on T19",
        procedureType: "inlay_onlay",
        status: "prescribed",
        target: {
          targetType: "single_tooth",
          jaw: "lower",
          teeth: ["T19"],
        },
        doctorNotes: "Conservative restoration preferred.",
        material: "Composite ceramic",
        shade: "A2",
        productionNotes: "Keep prep margins conservative.",
      },
    ],
    restorationPlans: [],
  },
  {
    summary: {
      caseId: "case-004",
      caseName: "Crowding Assessment",
      patientId: "patient-004",
      patientName: "Hina Malik",
      doctorName: "Dr. Maha Saeed",
    },
    jaws: {
      upper: {
        jawType: "upper",
        width: 98,
        depth: 38,
        height: 15,
        toothCount: 16,
      },
      lower: {
        jawType: "lower",
        width: 92,
        depth: 31,
        height: 0,
        toothCount: 16,
      },
    },
    prescriptionItems: [
      {
        itemId: "rx-007",
        title: "Custom Abutment on T28",
        procedureType: "custom_abutment",
        status: "in_planning",
        target: {
          targetType: "single_tooth",
          jaw: "lower",
          teeth: ["T28"],
        },
        doctorNotes: "Custom abutment needed for angulation correction.",
        material: "Titanium",
        shade: "",
        productionNotes: "Coordinate with implant library.",
      },
    ],
    restorationPlans: [],
  },
  {
    summary: {
      caseId: "case-005",
      caseName: "Occlusion Check",
      patientId: "patient-005",
      patientName: "Bilal Hussain",
      doctorName: "Dr. Areeba Yusuf",
    },
    jaws: {
      upper: {
        jawType: "upper",
        width: 112,
        depth: 48,
        height: 21,
        toothCount: 16,
      },
      lower: {
        jawType: "lower",
        width: 103,
        depth: 37,
        height: 3,
        toothCount: 16,
      },
    },
    prescriptionItems: [
      {
        itemId: "rx-008",
        title: "Crowns T2 and T3",
        procedureType: "crown",
        status: "prescribed",
        target: {
          targetType: "multiple_teeth",
          jaw: "upper",
          teeth: ["T2", "T3"],
        },
        doctorNotes: "Adjacent crowns with occlusion review.",
        material: "Zirconia",
        shade: "A2",
        productionNotes: "Check proximal contact design.",
      },
    ],
    restorationPlans: [],
  },
];